export default "__VITE_ASSET__CvY_5_41__"